import WarehouseImage from "./warehouseImage";

export default function Warehouse() {
  return (
    <>
      {/* <Banner _data={data.banner} /> */}

      <div className="warehouse-container">
        <h1 className="heading service">Intercity</h1>
        <p>
          We are a last-mile delivery solution provider through 4w EVs. Pickkup
          delivers reliable and eco-friendly intercity transport on key routes
          like Mohali → Delhi, Ludhiana, Jalandhar, Ambala, and Delhi → Jaipur.
          Timely, sustainable, and customer-focused logistics you can trust. To
          manage Fleet, Orders, and Workforce we offer <b>Trackk</b>, a robust
          tracking app that enables seamless order management, fleet
          supervision, real-time vehicle tracking, and vehicle audits. Our
          technology-driven approach ensures transparency, efficiency, and
          reliability at every step of the supply chain
        </p>
        <b>We do not use any kind of payment gateway for this service.</b>
      </div>
      <WarehouseImage />
    </>
  );
}
